import React from 'react';

import {connect} from 'react-redux';

import logo from '../assests/logo.png';
import '../static/css/header.css';
import {NavLink} from 'react-router-dom';

const currentUser = JSON.parse(localStorage.getItem('UserObject'));
const existLocation = JSON.parse(localStorage.getItem('location'));
console.log('loc', existLocation)

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userid: currentUser ? currentUser.email : 'My Account',
            location: existLocation ? existLocation : {country: 'UK(default)', city: ''}
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps)
    }

    header = () => (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <a className="navbar-brand" href="#">
                <img src={logo} width="30" height="30"
                     className="d-inline-block align-top" alt="euBines"/>
                euBines
            </a>
        </nav>
    )

    render() {
        console.log('store', this.props);
        const {location} = this.state;
        return (
            <div id="header" className="container-fluid border-bottom border-secondary mb-2">
                <div className="flex-container">
                    <div className="flexlogo align-items-center">
                        <div>
                            <NavLink to='/'><img src={logo} alt="Logo" id="logo"/></NavLink>
                        </div>
                        <div id="slogon" className="align-items-center">
                            <h4 className="mb-sm-0">euBines</h4>
                            <span className="d-flex flex-row">
                                   <i className="fa fa-map-marker-alt"/>
                                <small className="location-text">{this.props.location.currentLocation.city ?
                                    `${this.props.location.currentLocation.city},${this.props.location.currentLocation.country}`
                                    : location.city ? `${location.city},${location.country}` : location.country}
                                </small>
                            </span>
                        </div>
                    </div>
                    <div className="flexbtn pr-3" id="btn-group">
                        {
                            (!currentUser ? <NavLink to='/user/login'>
                                        <button type="button" className="btn btn-md-sm btn-outline-primary  resbtn"
                                                id="account-btn">
                                            <i className="fa fa-user"/>
                                            &nbsp;
                                            Login
                                        </button>
                                    </NavLink> :

                                    <div className="dropdown resbtn2">
                                        <button className="btn btn-secondary dropdown-toggle btn-lg" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">
                                            {this.state.userid.split(/@[a-z]*.com/)}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <NavLink to='/myaccount'><span className="dropdown-item">
                                            My Account</span></NavLink>
                                            <span className="dropdown-item" onClick={
                                                () => {
                                                    localStorage.removeItem('UserObject');
                                                    window.location = '/'
                                                }
                                            }>Log Out</span>
                                        </div>
                                    </div>
                            )
                        }
                        <div className="d-none d-sm-block">
                            <NavLink to={!currentUser ? '/user/login' : '/posting'}>
                                <button type="button" id="ad-btn"
                                        className="btn btn-md-sm btn-outline-warning resbtn3">Post an ad
                                </button>
                            </NavLink>

                        </div>
                    </div>


                </div>
                <div className="d-block d-sm-none" style={{
                    position: 'fixed',
                    bottom: 0,
                    marginBottom: '20px',
                    width: '100%',
                    zIndex: 10000
                }}>
                    <NavLink style={{width: '100%'}} to={!currentUser ? '/user/login' : '/posting'}>
                        <button style={{width: '85%'}} type="button" id="ad-btn"
                                className="btn btn-md-sm btn-outline-warning resbtn3">Post an ad
                        </button>
                    </NavLink>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    location: state.Settings,
    // any props you need else
});

export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js